import React from 'react';
import { Route } from 'react-router';

import TopicList from '../containers/TopicList';
import Article from '../containers/ArticlePanel';
import HomePage from '../components/HomePage';

import ArticleListByTopic from '../containers/ArticleListByTopic';

import SearchFilterForm from '../containers/SearchFilterForm';
import SearchResult from '../containers/SearchResult';

const routes = [
  { path: '/home',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <HomePage />,
  },
  { path: '/topic/:topicId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <ArticleListByTopic />,
  },
  { path: '/article/:articleId',
    exact: true,
    sideBar: () => <TopicList />,
    mainContainer: () => <Article />,
  },
  { path: '/search',
    exact: true,
    sideBar: () => <SearchFilterForm />,
    mainContainer: () => <SearchResult />,
  },
];

const SideBar = () =>
  <div>
    { routes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={route.sideBar}
      />
       ))
     }
  </div>;

const MainContainer = () =>
  <div>
    { routes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={route.mainContainer}
      />
       ))
     }
  </div>;

export default {
  sideBar: <SideBar />,
  mainContainer: <MainContainer />,
};
